import React from "react";
import { Helmet } from "react-helmet";
import "./Home.scss";
import HomeCards from "../../components/homeComponents/homeCards/homeCards";
import HomeBottomtext from "../../components/homeComponents/homeBottomtext/homeBottomtext";
import HomeHero2 from "../../components/homeComponents/homeHero/homeHero2";
import HomeTitleComponents from "../../components/homeComponents/homeTitleComponents/HomeTitleComponents";
import HomeStories from "../../components/homeComponents/homeStories/homeStories";

function Home() {
  return (
    <div>
      <Helmet>
        <title>TXT Labs – Home</title>
        <meta
          name="description"
          content="We drive client success and empower youth. Based in South Central Los Angeles, we build strong communities and promote diversity in tech with comprehensive services."
        />
        <link rel="canonical" href="https://txtlabs.io/" />
      </Helmet>
      <HomeHero2 />
      <div>
        <HomeCards />
      </div>
      <div>
        <HomeTitleComponents />
      </div>
      <div>
        <HomeStories />
      </div>

      <div>
        <HomeBottomtext />
      </div>
    </div>
  );
}

export default Home;
